import { render } from "./RoomAdd.vue?vue&type=template&id=209055a5&scoped=true"
import script from "./RoomAdd.vue?vue&type=script&lang=js"
export * from "./RoomAdd.vue?vue&type=script&lang=js"

import "./RoomAdd.vue?vue&type=style&index=0&id=209055a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209055a5"]])

export default __exports__